import { useState, useCallback } from 'react';

/**
 * useState that persists to localStorage.
 * Key is namespaced by userId to avoid cross-user contamination.
 *
 * @param {string} key       localStorage key suffix
 * @param {*}      fallback  default value when nothing is stored
 * @param {string} userId    user id for namespacing (optional)
 */
export function usePersistedState(key, fallback, userId) {
  const storageKey = userId ? `equipr_${userId}_${key}` : `equipr_${key}`;

  const [value, setValue] = useState(() => {
    try {
      const stored = localStorage.getItem(storageKey);
      return stored !== null ? JSON.parse(stored) : fallback;
    } catch {
      return fallback;
    }
  });

  const setPersisted = useCallback((next) => {
    setValue((prev) => {
      const resolved = typeof next === 'function' ? next(prev) : next;
      try {
        localStorage.setItem(storageKey, JSON.stringify(resolved));
      } catch { /* quota exceeded — ignore */ }
      return resolved;
    });
  }, [storageKey]);

  return [value, setPersisted];
}
